import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Column from '../../../../models/SpreadsheetReportConfigs/Column.js';
import { GenericDndItem } from '../../../molecules/GenericDnd';
import { DND_ITEM_TYPES } from '../../../../constants/SpreadsheetReportConfigs';

const OutputColumnDNDItem = ({
  groupName,
  column,
  index,
  onDelete,
  onUpdateName,
  originalLabel,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState(column.name);
  const shouldShowOriginalLabel =
    originalLabel && originalLabel !== column.name;

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleSaveClick = () => {
    if (editValue.trim()) {
      onUpdateName(column.id, editValue.trim());
      setIsEditing(false);
    }
  };

  const handleInputChange = (e) => {
    setEditValue(e.target.value);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && editValue.trim()) {
      handleSaveClick();
    } else if (e.key === 'Escape') {
      setEditValue(column.name);
      setIsEditing(false);
    }
  };

  return (
    <GenericDndItem
      index={index}
      itemType={DND_ITEM_TYPES.column}
      className='generic-dnd-boxed-item'
    >
      {(drag) => (
        <>
          <div ref={drag} className='generic-dnd-item-content'>
            <div className='generic-dnd-item-group-name'>{groupName}</div>
            {isEditing ? (
              <div className='generic-dnd-item-edit-wrapper'>
                <input
                  type='text'
                  value={editValue}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyPress}
                  className='generic-dnd-item-edit-input'
                  autoFocus
                />
                {shouldShowOriginalLabel && (
                  <span className='generic-dnd-item-original-name generic-dnd-item-original-name-editing'>
                    {`(${originalLabel})`}
                  </span>
                )}
              </div>
            ) : (
              <span className='generic-dnd-item-column-name'>
                {column.name}
                {shouldShowOriginalLabel && (
                  <span className='generic-dnd-item-original-name'>
                    {`(${originalLabel})`}
                  </span>
                )}
              </span>
            )}
          </div>
          <div className='generic-dnd-item-actions'>
            {isEditing ? (
              <>
                <i
                  className='fa fa-check generic-dnd-item-icon generic-dnd-item-icon-save'
                  onClick={handleSaveClick}
                />
                <i
                  className='fa fa-times generic-dnd-item-icon generic-dnd-item-icon-cancel'
                  onClick={() => {
                    setEditValue(column.name);
                    setIsEditing(false);
                  }}
                />
              </>
            ) : (
              <i
                className='fa fa-pencil generic-dnd-item-icon generic-dnd-item-icon-edit'
                onClick={handleEditClick}
              />
            )}
            <i
              className='fa fa-trash generic-dnd-item-icon generic-dnd-item-icon-delete'
              onClick={() => onDelete(column.id)}
            />
          </div>
        </>
      )}
    </GenericDndItem>
  );
};

OutputColumnDNDItem.propTypes = {
  groupName: PropTypes.string,
  column: PropTypes.shape(Column.propTypes).isRequired,
  index: PropTypes.number.isRequired,
  onDelete: PropTypes.func.isRequired,
  onUpdateName: PropTypes.func.isRequired,
  originalLabel: PropTypes.string,
};

export default OutputColumnDNDItem;
